module.exports = __webpack_public_path__ + "static/media/pa.beb40ab6.svg";